<template>
    <el-dialog
        custom-class="file-waiting-modal"
        :visible.sync="show"
        width="30%"
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        destroy-on-close
    >
        <div class="file-waiting-modal--body">
            <div v-if="isLoading" style="width: 100%;">
                <div v-loading="isLoading" :element-loading-text="loadingText"></div>
            </div>
            <div v-if="!isLoading">
                <div v-if="hasError" class="waiting-modal-text-error">
                    <img  class="image-modal" src="/static/image/error-icon-mark.svg" alt="icon error">
                    <p class="title-export">An error occurred while generating the export file.</p>
                    <p class="title-description">Please try again, if the problem persists, contact an administrator</p>
                </div>
                <div v-else class="waiting-modal-text">
                    <img class="image-modal" src="/static/image/check-icon.svg" alt="icon validate">
                    <p class="title-export">The export file has been generated.</p>
                    <p class="title-description">The download will start automatically.</p>
                </div>
            </div>
        </div>
        <span slot="footer">
            <div class="footer-container">
                <el-button
                    v-if="!isLoading"
                    class="close-button"
                    type="primary"
                    @click="close"
                >
                    Ok, close
                </el-button>
            </div>
        </span>
    </el-dialog>
</template>

<script>
import WaitingMixin from 'fundation-app-vuejs/src/components/partials/waitingMixin';
export default {
    mixins: [WaitingMixin],
    components: {

    },

    props: {
        loadingText: {
            type: String,
            default: 'File generation in progress...',
        },
    },

    data (){
        return {
            show: false,
        };
    },

    computed: {

    },

    mounted (){

    },

    methods: {
        open (){
            this.isLoading = true;
            this.show = true;
        },
        close (){
            this.show = false;
        },
        displayError (){
            this.isLoading = false;
            this.hasError = true;
        }
    },
};
</script>

<style lang="scss" scoped>

@import '../../../assets/styles/variables';
.waiting-modal-text-error{
    color: #FE5815;
    text-align: center;
    font-weight: 400;
}
.waiting-modal-text{
    color: #BBBBBB;
    text-align: center;
    font-weight: 400;
}
.file-waiting-modal--body{
    min-height: 200px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/WaitingModal/index.vue